<template>
  <div class="role-select-container">
    <div class="select-input" @click="toggleDropdown" :class="{ open: isOpen }">
      <div
        class="select-text d-flex flex-column justify-content-center"
        :class="{
          'align-items-center': !isChangeStyle,
          'format-padding': isChangeStyle,
        }"
      >
        <span class="font-weight-bold">
          {{ selectedOption ? selectedOption.name : "All Roles" }}
        </span>
        <span style="font-size: 11px">
          {{ selectedOption ? selectedOption.description : "" }}
        </span>
      </div>
      <svg
        class="dropdown-arrow"
        :class="{ rotated: isOpen }"
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
      >
        <path
          d="M1 1.5L6 6.5L11 1.5"
          stroke="#666"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div v-if="isOpen" class="dropdown-list">
      <div
        v-for="option in options"
        :key="option.value"
        class="dropdown-option"
        @click="selectOption(option)"
        :class="{ selected: value === option.value }"
      >
        <div>
          <div class="option-name">{{ option.name }}</div>
          <div class="option-description">{{ option.description }}</div>
        </div>
        <svg
          v-if="value === option.value"
          class="check-icon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M13.5 4.5L6 12L2.5 8.5"
            stroke="gray"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { booleanProp } from "@/helpers/props";

export default {
  name: "RoleSelectDropdown",
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    isChangeStyle: booleanProp(),
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    selectedOption() {
      return this.options.find((option) => option.value === this.value);
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.$emit("input", option.value);
      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.role-select-container {
  position: relative;
  width: 100%;
}

.select-input {
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  /* padding: 6px; */
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.select-input:hover {
  border-color: #9ca3af;
}

.select-input.open {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.select-text {
  color: #374151;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
}

.dropdown-arrow {
  transition: transform 0.2s ease;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 4px;
  overflow: hidden;
}

.dropdown-option {
  padding: 4px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.15s ease;
  border-bottom: 1px solid #f3f4f6;
}

.dropdown-option:last-child {
  border-bottom: none;
}

.dropdown-option:hover {
  background-color: #f9fafb;
}

.dropdown-option.selected {
  background-color: #f0f9ff;
}

.option-name {
  font-size: 12px;
  font-weight: 500;
  color: #111827;
}

.option-description {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
}

.check-icon {
  margin-left: 12px;
  flex-shrink: 0;
}

.format-padding {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>